import { FacetVm, TabVm } from 'qp-ui-interface';

/**
 * Get the tab icon based on the tab english data
 *
 * @param tabData
 * @returns
 */
export const getTabIcon = (tabData: string): string => {
  if (!tabData) return 'default';
  if (['home', 'all', 'movies', 'shows', 'search', 'my-content', 'settings', 'epg'].includes(tabData.toLowerCase())) {
    return tabData.toLowerCase().replace(' ', '-');
  }
  return 'default';
};

/**
 * Add client tabs to the tabsInfo
 *  - tvguide
 * - search
 * - myhub
 *
 * @param tabsInfo
 * @returns
 */
export const addClientTabs = (tabsInfo: TabVm[]): TabVm[] => {
  tabsInfo.splice(0, 0, {
    id: 'search',
    data: 'search',
    name: 'navbar.search',
    icon: 'search',
  });
  tabsInfo.push({
    id: 'epg',
    data: 'epg',
    name: 'navbar.tvguide',
    icon: 'tvguide',
  });
  tabsInfo.push({
    id: 'my-content',
    data: 'my-content',
    name: 'navbar.my-content',
    icon: 'my-content',
  });
  tabsInfo.push({
    id: 'myhub',
    data: 'myhub',
    name: 'navbar.settings',
    icon: 'settings',
  });
  return tabsInfo;
};

/**
 * Check if the facet is the all content
 *
 * @param facet
 * @returns
 */
export const isEpgAll = (facet: FacetVm) => {
  return facet && facet.term === 'all' && facet.field === '';
};
